import { CompassCardUI } from '@scale/compass-ui/types';
import {
  UpdateCourseProgressV2CardShared,
  type UpdateCourseProgressV2SchemaType,
  type UpdateCourseProgressV2Context,
  UPDATE_COURSE_PROGRESS_V2,
} from '@scale/genai-compass-shared/cards/update_course_progress_v2';
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons';
import UpdateCourseProgressV2CardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/UpdateCourseProgressV2Card/UpdateCourseProgressV2CardComponent';

const defaultContext: UpdateCourseProgressV2Context = {
  cardType: UPDATE_COURSE_PROGRESS_V2,
  autopermission: true,
  shouldTagUsers: false,
};

export const UpdateCourseProgressV2CardInfo: CompassCardUI<UpdateCourseProgressV2SchemaType> = {
  ...UpdateCourseProgressV2CardShared,
  title: 'Update Course Progress V2',
  icon: 'edit',
  toolTip: 'Update Course Progress V2.',
  defaultContext,
  ownerTeam: 'Outlier',
  button: {
    icon: faGraduationCap,
  },
  legacyComponent: UpdateCourseProgressV2CardComponent,
};
